import * as React from "react";
import { classes } from "../../../utils/ui";

function Input({
    className,
    type,
    variant = "default",
    label,
    placeholder,
    classNames,
    error,
    helperText,
    ...props
}: React.ComponentProps<"input"> & {
    variant?: "default" | "outlined" | "filled";
    label?: string;
    helperText?: string | React.ReactNode;
    error?: boolean;
    classNames?: {
        label: string;
    };
}) {
    const variantClasses = {
        default: "px-6 py-4 bg-white dark:bg-brand-100 border-box",
        outlined:
            "border p-4 bg-dropdownBg rounded-none leading-[18px] " +
            (error ? "border-red-500" : "border-dropdownBorder"),
        filled: "bg-lightGray-muted py-3 px-4",
    };

    return (
        <div className={classes("flex flex-col gap-2", className)}>
            {label && (
                <label
                    className={classes(
                        "text-xs font-normal text-white/40 leading-4 block",
                        classNames?.label
                    )}
                >
                    {label}
                </label>
            )}
            <input
                type={type}
                data-slot="input"
                placeholder={placeholder}
                className={classes(
                    "outline-none disabled:cursor-not-allowed disabled:hover:border-gray-line w-full flex border text-sm",
                    "placeholder:text-darkGray-400 font-normal text-foreground focus:border-none rounded-full",
                    variantClasses[variant],
                    className
                )}
                {...props}
            />
            {helperText && (
                <div className={`text-xs mt-1 ${error ? 'text-red' : ''}`}>
                    {helperText}
                </div>
            )}
        </div>
    );
}

export { Input };
